import { axiosInstance } from "./axios";
import useCustomQuery from "hooks/useCustomQuery";
import {
  IActivityReportResponse,
  ICasesReportResponse,
  IDateReportRequest,
  IIncomingReportResponse,
  IOutgoingReportResponse,
  IOverdueReportResponse,
  IPeriodReportRequest,
} from "dto/Reports/IReports";

// Raporty pracy urzędu (port „Raporty" z Magistratu) — POST api/reports/*.

const getIncoming = (r: IPeriodReportRequest): Promise<{ data: IIncomingReportResponse }> =>
  axiosInstance.post("reports/incoming", r);
const getOutgoing = (r: IPeriodReportRequest): Promise<{ data: IOutgoingReportResponse }> =>
  axiosInstance.post("reports/outgoing", r);
const getCases = (r: IPeriodReportRequest): Promise<{ data: ICasesReportResponse }> =>
  axiosInstance.post("reports/cases", r);
const getOverdue = (r: IDateReportRequest): Promise<{ data: IOverdueReportResponse }> =>
  axiosInstance.post("reports/overdue", r);
const getActivity = (r: IPeriodReportRequest): Promise<{ data: IActivityReportResponse }> =>
  axiosInstance.post("reports/activity", r);

const useIncomingReport = (r: IPeriodReportRequest, enabled = true) =>
  useCustomQuery(["reports.incoming", r], () => getIncoming(r), { enabled, keepPreviousData: true });
const useOutgoingReport = (r: IPeriodReportRequest, enabled = true) =>
  useCustomQuery(["reports.outgoing", r], () => getOutgoing(r), { enabled, keepPreviousData: true });
const useCasesReport = (r: IPeriodReportRequest, enabled = true) =>
  useCustomQuery(["reports.cases", r], () => getCases(r), { enabled, keepPreviousData: true });
const useOverdueReport = (r: IDateReportRequest, enabled = true) =>
  useCustomQuery(["reports.overdue", r], () => getOverdue(r), { enabled, keepPreviousData: true });
const useActivityReport = (r: IPeriodReportRequest, enabled = true) =>
  useCustomQuery(["reports.activity", r], () => getActivity(r), { enabled, keepPreviousData: true });

export default {
  useIncomingReport,
  useOutgoingReport,
  useCasesReport,
  useOverdueReport,
  useActivityReport,
};
